module.exports = __webpack_public_path__ + "img/tmall_2.e73387d2.jpg";